import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

class EmisorListItemActions extends Component {
  isOnlyOneItemSelected = () => {
    const { selectedRowKeys } = this.props;

    return selectedRowKeys.length === 1;
  };

  render() {
    const { selectedRows } = this.props;

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={true}
      >
        <Button variant="secondary">Acciones</Button>

        <Dropdown.Toggle
          split
          variant="secondary"
          id="dropdown-split-basic"
        />

        <Dropdown.Menu>
          {Guardian.allows('emisor.bloquear') && <Dropdown.Item href="#/action-1">Bloquear cuenta</Dropdown.Item>}

          {this.isOnlyOneItemSelected() && Guardian.allows('emisor.manifiesto') && (
            <Dropdown.Item
              as={Link}
              to={`/emisores/${selectedRows[0].id}/manifiesto`}
            >
              Subir manifiesto
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default EmisorListItemActions;
